import aodErrors from "./aodErrors";
import AodItemList from "./item/AodItemList";
import AodObjectFactory from "./object/AodObjectFactory";

const axios = require('axios');
const axiosRetry = require('axios-retry');
//const Promise = require('bluebird');

const _ = require('lodash');
const metroAuth = require('./metroAuth');

function AodService(options)
{
    this.config = _.merge({}, this.defaultConfig, options);

    this.factory = new AodObjectFactory(this);
    this.itemCalls = new AodItemList(this);

    this.client = this.initClient(options);

    // Not sure I want to get into doing this for all objects...
    // And it messes up debugging...
    //_.bindAll(this,'loginInfo','submitRequest','getUrl','getQueryUrl','applicationInfo');
}

function goodResponse(response)
{
    // regular call return 0
    // values above zero have other (succesful) meaning
    // render[0]- sucessful render, render[1]- no render needed

    // If its not json assumes its OK (check headers?)
    return response.config.responseType !== 'json' ||
        ( _.isObject(response.data) && ('status' in response.data) && response.data.status >= 0);
}


AodService.prototype = {

    defaultConfig: {
        baseURL: 'https://projects2.metrocreativeconnection.com/rest',
        userName: 'test',
        password: 'test',
        timeout: 30000,
        clientVersion: '2.2.3',
        allowRetryErrors: [
            aodErrors.OPTIMISTIC_LOCK_FAILURE,
            aodErrors.MIAD_LOGIN_FAILURE,
            aodErrors.MIAD_COMMAND_FAILURE,
            aodErrors.EXTERNAL_COMMAND_FAILURE,
            aodErrors.MANAGED_FILE_UPLOAD_FAILED,
            //aodErrors.NOT_LOGGED_IN  //TEST!!
        ],
        commandRetries: 1, // i.e. got a json response
        networkRetries: 3, // network/server error retries,
        loginCallback: null  // returns loginInfo,  needed when auto login supported
    },

    // todo - ? attach mcc api
    //  ? still needed in projects & project items
    // getMccUrl( 'thumb.jpg', {FILENAME: this.metroName})
    getMccUrl:  function getMccUrl(urlFileName, data)
    {
        return 'mccUrl' ;
    },

    isOnLine: function isOnLine() {
        // Navigator is a browser only object
        //return !navigator || navigator.onLine;
        // todo make this smarter
        return true;
    },

    getQueryUrl: function getQueryUrl(path)
    {
        return this.getUrl() + path;
    },

    getUrl: function(){
        return this.config.baseURL;
    },

    initClient: function initClient(options){
        const instanceOptions = _.pick(this.config, 'baseURL','timeout');
        const client = axios.create(instanceOptions);
        const {allowRetryErrors} = this.config;

        function allowRetry(response)
        {
            return response.config.responseType === 'json' &&
                _.isObject(response.data) && ('status' in response.data) &&
                _.includes(allowRetryErrors,response.data.status);
        }

        // AOD retry
        //this.client.interceptors.request.use(config  => {
        //    if( !('retries' in config)){
        //       config.retries = this.config.commandRetries ;
        //    }
        //    return config;
        //});

        function ensureGoodAodResponse(response)
        {
            if (response.config.retries > 0 &&
                !goodResponse(response) &&
                allowRetry(response))
            {
                response.config.retries --;
                fixConfig(client, response.config); //TBD still needed

                // NOTE:
                //This works using latest mergeConfig.js from github for axios (not 19.0)
                console.log('Retrying: ', response.config.retries);
                return client(response.config);  //try again
            }

            // todo ? try axios-cookiejar-support (possibly did already... )
            // !! unpacking anything except an array bable throws an error (same as js)
            const cookieHeader = response.headers["set-cookie"];
            if (_.isArray(cookieHeader)) {
                const [cookie] = cookieHeader; // get cookie from request
                client.defaults.headers.Cookie = cookie; // attach cookie to axiosInstance for future requests
            }

            return response; //?Promise.resolve(response);
        }

        // AOD retry if server 200 response with error message (and grab session cookie)
        client.interceptors.response.use(ensureGoodAodResponse);

        // Network retries
        // apply 2nd as I think inteceptors fire in reverse order
        axiosRetry(client, { retries: this.config.networkRetries });

        return client;
    },


    // todo auto login on NOT_LOGGED in error
    submitRequest: function (options) {

        //var self = this;
        if (!this.isOnLine()) {
            return Promise.reject({status: 1000}, 'offline').promise();
        }

        var callConfig = _.merge({
                url: options.queryPath,
                withCredentials: true,
                timeout: this.config.timeout,
                retries: this.config.commandRetries, // see cutomer interceptor
                responseType: 'json' //TBD other response type - assets, reports ....
            },
            options);

        return this.client(callConfig)
            .then(function(response){
                if (!goodResponse(response) )
                {
                    // Assume if we have data it does have a message & status
                    const data = response.data || {
                        message: 'Missing JSON data',
                        status: '-1000'
                    };

                    //Note: this throws a warning could use Custom error
                    return Promise.reject({
                        response,
                        message: data.message,
                        status: data.status
                    });
                }

                return response.data;
            }).catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    //OR
                    // and OAD status less than 0
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);

                throw error;
            });
    },

    loginInfo: function()
    {
        return this.submitRequest({
            queryPath: 'loginInfo'
        });
    },

    login: function(info)
    {
        const self = this;
        const authOptions = {}; //{shaPassword:true}
        this.loggedIn = false;
        // TBD if this.loggedIn THEN logout?;
        //TBD ? would relogin in fail but you'd still be logged in

        return this.submitRequest({
            method: 'POST',
            queryPath: 'login',
            params: {
                view: 'normal',
                quick:true,
                clientVersion: this.config.clientVersion
            },
            data: metroAuth.encode(this.config.userName, this.config.password, info||{}, authOptions),
            timestamp: false,
            retries: 0
        })
            .then( async function(data)
            {
                self.loggedIn = true;
                if (self.loginCallback) {
                    await self.loginCallback(data);
                }
                return data;
            });
        // todo fail / catch
    },

    logout:function()
    {
        return this.submitRequest({  // TBD logout can fail, leaving you logged in ...
            queryPath: 'logout',
            timestamp: false
        });
        // TBD blat the JSSSIONID as well - otherwise conectin may get reused for a differnt user if logout call 'fails'
        // ??return this.ready ;
        // NOTE:  is mcc session is still set & valid autoLogin will will just kick in anyway
    },

    applicationInfo: function()
    {
        return this.submitRequest({
            queryPath: 'applicationInfo',
            timestamp:false
        });
    },

    renderInfo: function()
    {
        return this.submitRequest({
            queryPath: 'renderInfo'
        });
    },

    report: function(template, sql, native, title, description)
    {
        var record = {
            reportBeans: {
                title: title,
                description: description || "",
                nativeQuery: native,
                query: sql
            }
        };
        return this.submitRequest({
            queryPath: 'report/run/'+template,
            method: 'POST',
            data: record,
            timestamp:false
        });
    },

    //Not used
    getErrorMessage: function getErrorMessage(jqXHR, textStatus, errorThrown, url)
    {
        if (jqXHR.status === 1000) {  // fake code if device not on network
            return 'No network connection.';
        } else if (jqXHR.status === 0) {
            return 'Unable to reach the MiAD server.\n Please check your network connections.';
        } else if (jqXHR.status === 404) {
            return 'Requested page not found. [404] '+url;
        } else if (jqXHR.status === 500) {
            return 'Internal Server Error [500] '+url;
        } else if (textStatus === 'parsererror') {
            return 'Requested JSON parse failed. '+url;
        } else if (textStatus === 'timeout '+url) {
            return 'Time out error. '+url;
        } else if (textStatus === 'abort') {
            return 'Request aborted. '+url;
        } else {
            return 'Unknown Error.\n' + jqXHR.responseText ;
        }
    }
};

// Axios fails merging this configuration to the default configuration because it has an issue
// with circular structures: https://github.com/mzabriskie/axios/issues/370
/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */
//Taken from axios-retry
// Not sure its needed
function fixConfig(axios, config) {
    if (axios.defaults.agent === config.agent) {
        delete config.agent;
    }
    if (axios.defaults.httpAgent === config.httpAgent) {
        delete config.httpAgent;
    }
    if (axios.defaults.httpsAgent === config.httpsAgent) {
        delete config.httpsAgent;
    }
}

//module.exports =  AodService;
export default AodService;